import React from 'react';

import { isProd } from '@src/config/env.config';

import helpCenterStore from './helpCenter.store';

const stores = {
  helpCenterStore,
};

if (!isProd) {
  // @ts-ignore
  window['stores'] = stores;
}

const StoresContext = React.createContext(stores);
StoresContext.displayName = 'StoresContext';

function useStores() {
  return React.useContext(StoresContext);
}

export type Stores = typeof stores

export { stores, StoresContext, useStores };
